export default function SecurityGroupViewUserSelectionModalController(
  $rootScope,
  $scope,
  $uibModal,
  $stateParams,
  $filter,
  usersService,
  $uibModalInstance,
  selectedUsers,
  singleSelect,
  gettextCatalog,
) {
  'ngInject';

  $scope._selectedUsers = selectedUsers ? selectedUsers : {};
  $scope.filteredUsers = [];

  //Pagination
  $scope.current = { userListPage: 1, selectedUsersPage: 1 };
  $scope.itemsPerPage = 15;
  $scope.maxSize = 3;

  //displayUsersByPage() is used to set the legnth of paging needed for filteredUsers.
  $scope.displayUsersByPage = function () {
    $scope.totalItems = $scope.filteredUsers.length;
    var begin = ($scope.current.userListPage - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    $scope.usersByPage = $scope.filteredUsers.slice(begin, end);
  };

  $scope.displaySelectedUsersByPage = function () {
    var begin = ($scope.current.selectedUsersPage - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    return Object.keys($scope._selectedUsers).slice(begin, end);
  };

  //Calls displayUsersByPage(), everytime the the user changes the page.
  $scope.userPageChanged = function () {
    $scope.displayUsersByPage();
    GTM_AvailableListChanged('userModalAvailablePageChanged');
  };

  $scope.selectedUserPageChanged = function () {
    $scope.displaySelectedUsersByPage();
    GTM_SelectedListChanged('userModalSelectedPageChanged');
  };

  //applyFilter searchs the userData[] for anything matching the search input.
  $scope.applyFilter = function (loading = false) {
    $scope.filteredUsers = $filter('filter')($scope.users, $scope.searchString);
    $scope.displayUsersByPage();
    GTM_AvailableListChanged(loading ? 'userModalAvailableLoaded' : 'userModalAvailableFiltered');
  };

  var refresh = function () {
    if ($scope.loading) {
      $scope.isDirty = true;
      return;
    }

    $scope.loadingUsers = true;
    usersService
      .getUsers()
      .then(
        function (response, status, headers) {
          $scope.users = response.data;
          for (var i = 0; i < $scope.users.length; i++) {
            if ($scope.users[i].verified && !$scope.users[i].password.isSet) {
              $scope.users.splice(i, 1);
              i--;
            }
          }
          $scope.filteredUsers = $scope.users.slice();
          $scope.applyFilter(true);
          $scope.displaySelectedUsersByPage();
          $scope.loading = false;
        },
        function (error) {
          var errorMsg = gettextCatalog.getString('An error occurred while retrieving user info');
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg =
                error.data.message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
        },
      )
      .finally(function () {
        $scope.loadingUsers = false;
      });
  };

  var deselectUser = function (user) {
    if (!user) return;

    delete $scope._selectedUsers[user];
    $scope.displaySelectedUsersByPage();
  };

  $scope.selectUser = function (user) {
    if (!user) return;

    //if user cann't select himself  userCannotSelectHimself should pass in when openning the modal
    if ($scope.userCannotSelectHimself && $rootScope.currentUser.id === user.id) {
      return;
    }

    if (!singleSelect) {
      if (!$scope._selectedUsers[user.id]) {
        $scope._selectedUsers[user.id] = user;
        GTM_AvailableListChanged('userModalAvailableUserSelected');
      } else {
        deselectUser(user.id);
        GTM_AvailableListChanged('userModalAvailableUserUnselected');
      }
    } else {
      $scope._selectedUsers = {};
      $scope._selectedUsers[user.id] = user;
      GTM_AvailableListChanged('userModalAvailableSingleUserSelected');
    }
    $scope.displaySelectedUsersByPage();
  };

  $scope.removeUser = function (user) {
    if (!user) return;

    deselectUser(user);
    GTM_SelectedListChanged('userModalSelectedRemovedUser');
  };

  $scope.numSelectedUsers = function () {
    return Object.keys($scope._selectedUsers).length;
  };

  //BUTTON EVENTS
  $scope.confirm = function () {
    $uibModalInstance.close($scope._selectedUsers);
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.$on('$locationChangeStart', function (event, next, current) {
    // Here you can take the control and call your own functions:

    $scope.cancel();
    event.preventDefault();
  });

  //INIT
  refresh();

  function GTM_SelectedListChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.numSelectedUsers(),
        pageNumber: $scope.current.selectedUsersPage,
      },
    });
  }

  function GTM_AvailableListChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.users.length,
        totalFiltered: $scope.filteredUsers.length,
        totalSelected: $scope.numSelectedUsers(),
        pageNumber: $scope.current.userListPage,
      },
    });
  }
}
